export default "__VITE_ASSET__B388JQFO__"